import React from "react";
import styled from "styled-components";
import { TooltipContainerStyle } from "../Toggletip";
import { GraphLegendText } from "./GraphLegend";

type VerticalBarGraphProps = {
    data:{
        value:number,
        color:string,
        legendText?:React.ReactNode,
        tootip?:React.ReactNode,
    }[],
    barHeightPx:number,
    heightMode:'total-sum' | 'max-value'
    gapPx?:number,
    legendGap?:number,
    showValueDecimals?:boolean
}
export function VerticalBarGraph(props:VerticalBarGraphProps):JSX.Element
{
    const validSegments = props.data.filter(segment => segment.value > 0);
    const valueTotal = validSegments.reduce((acc, segment) => acc + segment.value, 0);
    const valueMax = Math.max(...validSegments.map(segment => segment.value));

    const safeHeightPx = Math.max(50, props.barHeightPx);

    return (
        <div style={{display:'flex', flexDirection:'column', gap:props.legendGap || 4}}>
            <div style={{display:'flex', alignItems:'flex-end', gap:`${props.gapPx || 2}px`}}>
                {validSegments.map((segment, index) => {

                    const segmentHeight = props.heightMode === 'max-value'
                        ? segment.value / valueMax * safeHeightPx
                        : segment.value / valueTotal * safeHeightPx;

                    const pctValue = segment.value / valueTotal * 100;

                    return (
                        <VerticalContainer key={index}>
                            <GraphSegmentContainer key={index} height={`${safeHeightPx}px`}>
                                <GraphSegment
                                    color={segment.color}
                                    height={`${segmentHeight}px`}
                                    showHoverEffect={segment.tootip !== undefined}>
                                    
                                </GraphSegment>
                                
                            </GraphSegmentContainer>
                            <LegendContainer color={segment.color}>
                                <GraphLegendText>
                                    {segment.legendText || `${pctValue.toFixed(props.showValueDecimals ? 1 : 0)}% / (${segment.value})`}
                                </GraphLegendText>
                            </LegendContainer>
                        </VerticalContainer>
                    );
                })}
            </div>
        </div>
    );
}

const VerticalContainer = styled.div`
    flex: 1 1 0;
    width: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    gap:4px;
`;

const GraphSegmentContainer = styled.div<{height:string}>`
    height: ${props => props.height};
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
`;

const GraphSegment = styled.div<{ color:string, height:string, showHoverEffect:boolean }>`
    display: flex;
    justify-content: center;
    align-items: center;
    position:relative;
    background-color:${props => props.color};
    height:${props => props.height};
    font-size:11px;
    
    ${props => props.showHoverEffect && `
        &:hover {
            outline: 1px solid ${'gray'/*Colors.neutral.palette.shade20*/};
            & ${SegmentTooltip}{
                visibility: visible;   
                opacity: 1;
            }
        }`
    }
`;

const SegmentTooltip = styled.div<{width:string }>`
    visibility: hidden;
    width: ${props => props.width};
    ${TooltipContainerStyle};
    position: absolute;
    z-index: 10;
    bottom: -25px;
    opacity: 0;
    transition: opacity 0.3s;
`;

const LegendContainer = styled.div<{color:string}>`
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 3px solid ${props => props.color};
    height:24px;
`;